import { useInfiniteQuery } from '@tanstack/react-query';
import { getAllCreatedAudios } from '../../services';
import { AudioModelType, FilteringSortingParams } from '../../../t2c-fe/utils';

export const useGetAllCreatedAudios = (params: FilteringSortingParams, model?: AudioModelType, name?: string, genType?: string) => {
  return useInfiniteQuery(
    ['getAllBuildAudios', params, model, name, genType],
    ({ pageParam = 1 }) => getAllCreatedAudios({ ...params, page: pageParam }, model, name, genType),
    {
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length;
        const totalItemsFetched = currentPage * (params?.limit ?? 20);

        if (totalItemsFetched < lastPage.count) {
          return currentPage + 1;
        } else {
          return undefined;
        }
      },
    }
  );
};
